var __TEMP__ = require('./_baseRepeat.js');var baseRepeat = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseToString.js');var baseToString = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_castSlice.js');var castSlice = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hasUnicode.js');var hasUnicode = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stringSize.js');var stringSize = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stringToArray.js');var stringToArray = __REQUIRE_DEFAULT__(__TEMP__);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars)
    ? castSlice(stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = createPadding;
